module.exports = __webpack_public_path__ + "static/christian-ab5b51b76eced092dcdbb47b1b0903fa.png";